<template>
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="分类名称">
          <a-select
            v-model="input.Ptid"
            style="width: 250px"
            default-value="1"
            @change="query()"
          >
            <a-select-option
              v-for="item in selectOption.termName"
              :key="item.ID"
            >
              {{ item.Name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="派送">
          <a-select
            v-model="input.State"
            style="width: 150px"
            @change="query()"
          >
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="1"> 未领取</a-select-option>
            <a-select-option value="2"> 已领取</a-select-option>
            <a-select-option value="3"> 已逾期</a-select-option>
            <a-select-option value="4"> 已派送</a-select-option>
            <a-select-option value="5"> 未达条件</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="会员名">
          <a-input v-model="input.User" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="query()"
            ><a-icon type="search"
          /></a-button>
        </a-form-item>
        <br>
        <a-form-item>
          <a-button type="primary" class="marr10" icon="download" @click="Export('Export')">
              导出派送状态数据
            </a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="marr10" icon="download" @click="Export('All')">
              导出期别数据
            </a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="marr10" icon="download" @click="Export('select')">
              导出已勾选数据
            </a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      bordered
      size="small"
      row-key="ID"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :loading="loading"
      :columns="columns"
      :data-source="datarow"
      :pagination="pagination"
      @change="changepage"
    >
      <template slot="title">
        <a-row :gutter="24">
           <a-col :span="5" style="line-height: 30px; width: 280px">
            查询 <span class="fontred">{{ clockNumer }}</span> 秒后刷新
            <a-button type="primary" @click="closeClock()">{{
              clockName
            }}</a-button>
          </a-col>
          <a-col style="float: right">
            <a-button type="delete" icon="delete" @click="BatchDelete(2)">
              删除本期
            </a-button>
          </a-col>
          <a-col style="float: right">
            <a-button type="delete" icon="delete" @click="BatchDelete(1)">
              批量删除
            </a-button>
          </a-col>
          <a-col style="float: right">
            <a-button type="primary" icon="rest" @click="Offunread()">
              逾期全部未领取
            </a-button>
          </a-col>
          <a-col style="float: right">
            <a-button type="primary" icon="rest" @click="AllPayOut()">
              批量已领取改为已派送
            </a-button>
          </a-col>
          <a-col style="float: right">
            <a-button
              type="primary"
              :disabled="fileList.length === 0"
              :loading="uploading"
              @click="handleUpload"
            >
              {{ uploading ? "上传" : "开始上传" }}
            </a-button>
          </a-col>
          <a-col style="float: right">
            <a-upload
              :file-list="fileList"
              :remove="handleRemove"
              :before-upload="beforeUpload"
            >
              <a-button> <a-icon type="upload" /> 选择文件 </a-button>
            </a-upload>
          </a-col>
          <a-col style="float: right">
            <a-button type="primary" @click="dowTemplate"> 下载模板 </a-button>
          </a-col>
        </a-row>
      </template>
      <template slot="State" slot-scope="text, record">
        <span style="color: red" v-if="record.State == '1'">未领取</span>
        <span style="color: blue" v-else-if="record.State == '2'">已领取</span>
        <span style="color: orange" v-else-if="record.State == '3'"
          >已逾期</span
        >
        <span style="color: green" v-else-if="record.State == '4'">已派送</span>
        <span style="color: red" v-else-if="record.State == '5'">未达条件</span>
      </template>
      <template slot="Operation" slot-scope="text, record">
        <a-tooltip v-if="record.State == '4'" title="取消派送">
          <a @click="Savestate(2, record)">
            <a-icon type="close-square" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        <a-tooltip v-else title="标记派送">
          <a @click="Savestate(1, record)">
            <a-icon type="check-square" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        &nbsp;&nbsp;
        <a-tooltip title="删除">
          <a @click="Delete(record)">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
      </template>
    </a-table>
  </a-layout-content>
</template>
<script>
import XLSX from "xlsx";
import { jsonExportSheet } from "../../js/xlsxTool";
import { arrayExport } from "../../js/xlsxTool";
export default {
  data() {
    return {
      datarow: [],
      columns: IninTable(),
      fileList: [],
      exportaction: "All",
      clockNumer: 15,
      clockName: "停止刷新",
      principalPolling: undefined,
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true, // 可以改变每页个数
        pageSizeOptions: ["10", "50", "100", "200", "1000", "5000"],
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
      },
      loading: false,
      uploading: false,
      input: { User: "", Ptid: 1, State: "0" },
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      selectedRowKeys: [],
      selectOption: {
        termName: [],
      },
      tableSorter:{
        Ldt:1
      }
    };
  },
  methods: {
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      if (!this.isExcel(file)) {
        this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
        return false;
      }
      this.fileList = [file];
      return false;
    },
    handleUpload() {
      this.uploading = true;
      const that = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array", raw: true });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header = that.getHeaderRow(worksheet);
          // 改变头部
          worksheet["A1"].w = "User";
          worksheet["B1"].w = "Amount";
          worksheet["C1"].w = "Result";
          worksheet["D1"].w = "Rebet";
          worksheet["E1"].w = "Winlose";
          worksheet["F1"].w = "Principal";
          const results = XLSX.utils.sheet_to_json(worksheet);
          this.generateData({ header, results });
          resolve();
        };
        reader.readAsArrayBuffer(that.fileList[0]);
      });
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        let hdr = "UNKNOWN " + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    generateData({ header, results }) {
      //进行上传
      this.uploading = false;
      this.fileList = [];
      this.axios
        .post("/principal/importprincipalrank", {
          PtID: parseInt(this.input.Ptid),
          PrincipalRankUserInfo: results,
        })
        .then((res) => {
          if (res.data) {
            this.mymessage(this, "导入成功");
            this.query();
          }
        });
    },
    // 下载模板
    dowTemplate() {
      var aoa = [
        ["会员账号", "投注金额", "派彩", "返水", "负盈利", "翻本金"],
        ["DEMO", "1111.22", "-555.33", "55.33", "-500.00(注意要负号)", "66.12"],
      ];
      arrayExport(aoa, "模板");
    },
    //翻页
    changepage(pagination, filters, sorter, extra) {
      //console.log('params', pagination, filters, sorter, extra);
      //排序
      if(sorter.hasOwnProperty("order")){
        if(sorter.order === "ascend"){
          //正序排序
          this.tableSorter.Ldt = 0;
        }
        else{
          //倒序排序
          this.tableSorter.Ldt = 1;
        }
      }
      else{
        //无排序
          this.tableSorter.Ldt = 1;
      }

      this.pagination.pageindex = pagination.current;
      this.pagination.pagesize = pagination.pageSize;
      this.query();
    },
    //批量选取
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    query() {
      let params = {
        PtID: this.input.Ptid,
        User: this.input.User,
        State: this.input.State,
        Ldt: this.tableSorter.Ldt,
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
      };
      this.axios.post("/principal/getprincipalranklist", params).then((res) => {
        this.datarow = res.data;
        this.pagination.total = res.total;
      });
    },
    //
    Export(flag) {
      if(flag === "select"){
        if (this.selectedRowKeys.length < 1) {
        this.$message.warning("请勾选数据");
        return;
        }
      }
      this.exportaction = flag;
      const _this = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出筛选数据吗？",
        onOk() {
          let IDList = [];
          _this.selectedRowKeys.forEach((element) => {
            IDList.push({ ID: element });
          });

          if(flag === "select"){
            _this.ExportSelectData({
              IDList: IDList,
              Type: 1
            });
          }
          else{
            _this.ExportData({
              PtID: _this.input.Ptid,
              User: flag === "All" ? "" : _this.input.User,
              State: flag === "All" ? 0 : _this.input.State,
              pageindex: 0,
              pagesize: 0,
            });
          }
          
        },
      });
    },
    //导出
    ExportData(data) {
      let today = new Date();
      this.$message.success(
        "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
      );
      this.axios({
        url:
          this.exportaction === "Export"
            ? "/principal/exportprincipalranklist"
            : "/principal/exportallprincipalranklist",
        method: "post",
        data: data,
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download =
            "翻本金- " + today.toISOString().split("T")[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
    //批量勾选导出
    ExportSelectData(data) {
      let today = new Date();
      this.$message.success(
        "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
      );
      this.axios({
        url: "/principal/exportallprincipalranklist",
        method: "post",
        data: data,
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download =
            "翻本金- " + today.toISOString().split("T")[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
    Savestate(type, record) {
      //type 1:派送 2:取消派送
      if (type === 1 && record.State.toString() != "2") {
        this.$message.warning("领取后才能派送!");
        return false;
      }
      let state = type === 1 ? 4 : 2;
      let IDList = [];
      IDList.push({ ID: record.ID });
      let params = {
        PtID: parseInt(this.input.Ptid),
        IDList: IDList,
        State: state,
      };
      this.axios
        .post("/principal/principalranksavestate", params)
        .then((res) => {
          if (res.data) {
            this.$message.success("更新成功");
            this.query();
          }
        });
    },
    Offunread() {
      let that = this;
      this.$confirm({
        title: "逾期全部未领取",
        content: "您要确定要操作逾期全部未领取吗",
        onOk() {
          let IDList = [];
          let params = {
            PtID: parseInt(that.input.Ptid),
            IDList: IDList,
            State: 3,
          };
          that.axios
            .post("/principal/principalrankoffunread", params)
            .then((res) => {
              if (res.data) {
                that.$message.success("操作成功");
                that.query();
              }
            });
        },
      });
    },
    AllPayOut(){
      let that = this;
      this.$confirm({
        title: "排行榜勾选状态改为已派发",
        content: "您要确定要操作勾选状态改为已派发吗",
        onOk() {
          let IDList = [];
          that.selectedRowKeys.forEach((element) => {
            IDList.push({ ID: element });
          });
          let params = {
            PtID: parseInt(that.input.Ptid),
            IDList: IDList,
            State: 3,
          };
          that.axios
            .post("/principal/principalrankallpayout", params)
            .then((res) => {
              if (res.data) {
                that.$message.success("操作成功");
                that.query();
              }
            });
        },
      });
    },
    Delete(record) {
      const that = this;
      this.$confirm({
        title: "删除数据",
        content: "您要确定要删除数据吗?",
        onOk() {
          let IDList = [];
          IDList.push({ ID: record.ID });
          let params = {
            PtID: parseInt(that.input.Ptid),
            IDList: IDList,
          };

          that.axios
            .post("/principal/principalrankdelete", params)
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.query();
              }
            });
        },
      });
    },
    BatchDelete(type) {
      if (this.selectedRowKeys.length < 1 && type === 1) {
        this.$message.warning("请勾选数据");
        return;
      }

      let url = "",
        content = "",
        title = "";
      switch (type) {
        case 1: //批量删除
          url = "/principal/principalrankbatchdelete";
          content = "您确定要删除勾选数据吗";
          title = "批量删除";
          break;
        case 2: //本期删除
          url = "/principal/principalrankdeleteterm";
          content = "您确定要删除本期数据吗";
          title = "删除本期";
          break;
      }

      let that = this;
      this.$confirm({
        title: title,
        content: content,
        onOk() {
          let IDList = [];
          that.selectedRowKeys.forEach((element) => {
            IDList.push({ ID: element });
          });
          that.axios
            .post(url, {
              PtID: parseInt(that.input.Ptid),
              IDList: IDList,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("操作成功");
                that.query();
              }
            });
        },
      });
    },
    //查询下拉限制
    qrydrpItem() {
      let _this = this;
      let params = {
        Name: "",
        pageindex: 0,
        pagesize: 0,
      };
      this.axios
        .post("/principal/getprincipaltermsetlist", params)
        .then((res) => {
          this.input.Ptid = parseInt(res.data[0].ID);
          this.selectOption.termName = res.data;
        });
      setTimeout(function () {
        _this.query();
      }, 1000);
    },
    //计时
    clockprincipal() {
      const routes = this.$route.matched.concat().pop();
      if (routes.name === "principalrank") {
        //clearInterval(this.principalPolling); //关闭
        if (this.clockNumer === 1) {
          this.query();
          this.clockNumer = 15;
        } else if (!this.loading) {
          this.clockNumer = this.clockNumer - 1;
        }
      }
    },
    closeClock() {
      if (this.clockNumer !== "--") {
        this.clockName = "启动刷新";
        this.principalPolling = clearInterval(this.principalPolling);
        this.clockNumer = "--";
      } else {
        this.clockName = "停止刷新";
        this.principalPolling = self.setInterval(this.clockprincipal, 1000);
        this.clockNumer = 15;
      }
    },
  },
  watch: {},
  //首次加载
  created() {
    this.qrydrpItem();
    this.principalPolling = self.setInterval(this.clockprincipal, 1000);
  },
  mounted() {},
};

const IninTable = function IninTable() {
  var header = [];
  header.push({
    title: "分类",
    align: "center",
    dataIndex: "PtName",
  });
  header.push({
    title: "会员名",
    align: "center",
    dataIndex: "User",
  });
  header.push({
    title: "创建时间",
    align: "center",
    dataIndex: "Fdt",
  });
  header.push({
    title: "已领取时间",
    align: "center",
    width: 400,
    sorter: (a, b) =>
      new Date(a.Ldt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
      new Date(b.Ldt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    dataIndex: "Ldt",
  });
  header.push({
    title: "投注金额",
    align: "center",
    dataIndex: "Amount",
  });
  header.push({
    title: "派彩",
    align: "center",
    dataIndex: "Result",
  });
  header.push({
    title: "返水",
    align: "center",
    dataIndex: "Rebet",
  });
  header.push({
    title: "负盈利",
    align: "center",
    dataIndex: "Winlose",
  });
  header.push({
    title: "翻本金",
    align: "center",
    dataIndex: "Principal",
  });
  header.push({
    title: "状态",
    align: "center",
    scopedSlots: { customRender: "State" },
  });
  header.push({
    title: "操作",
    align: "center",
    scopedSlots: { customRender: "Operation" },
    width: 200,
  });

  return header;
};

function stringIsNullorEmpty(value) {
  return !value || value == undefined || value == "" || value.length == 0;
}
</script>

<style>
#editor1 {
  height: 200px;
}
.borderclass {
  border: 1px solid rgb(211, 204, 204);
  width: 50%;
}
.marr10 {
  margin-right: 10px;
  background-color: green;
}
</style>


// WEBPACK FOOTER //
// src/components/principal/principalrank.vue